import { UNSAVED_NEW_NODE } from '../constants';
/**
 * Add key and title fields to a TreeRecord.
 *
 * These fields are required by rc-tree.
 *
 * Use the id field as source for the key, and turns it into a string
 * (since keys must be strings in rc-tree).
 *
 * @param {TreeRecord} treeRecord The record to augment
 * @param {string} titleField the name of the field or the record representation to use for title
 *
 * @returns {RCTreeDatum} A new record object with key and title
 *
 * @example
 *
 * getRCTreeDatum({ id: 1, name: 'hello', children: [] })
 * => {
 *   id: 1,
 *   name: 'hello',
 *   children: [],
 *   key: '1',
 *   title: 'hello',
 * }
 */
var getRCTreeDatum = function (treeRecord, titleField, new_node_title) {
    if (new_node_title === void 0) { new_node_title = 'new node'; }
    var getTitle = function () {
        if (treeRecord.id === UNSAVED_NEW_NODE) {
            return new_node_title;
        }
        if (typeof titleField === 'function') {
            return titleField(treeRecord);
        }
        return treeRecord[titleField];
    };
    return {
        id: treeRecord.id,
        record: treeRecord,
        key: String(treeRecord.id), // rc-tree only works with string keys
        title: getTitle(),
    };
};
export default getRCTreeDatum;
